import { Breadcrumbs, H5 } from "../../../AbstractElements";
import { Card, CardBody, CardHeader, Col, Container, Row ,Input,FormGroup,Label} from "reactstrap";
import React, { Fragment } from "react";
import TicketBoard from "./TicketBoard";
import TicketDetail from "./TicketDetails";

const TicketBoardContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle="Tickets" parent="Apps" title="Tickets" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
        
              <CardBody>
                <TicketBoard/>
                {/* <TicketDetail /> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default TicketBoardContainer;
